export enum Language {
  Chinese = 'zh',
  Dutch = 'nl',
  English = 'en',
  French = 'fr',
  German = 'de',
  Spanish = 'es'
}
